// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"515":"auth-layout","535":"login","685":"register","870":"pokemon"}[chunkId] || chunkId) + "." + {"492":"897b5b14","515":"fcb0a290","535":"5b026a38","685":"3b04f162","870":"2a0a3eaf"}[chunkId] + ".js";
};